<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="5">
        <el-input placeholder="会员id" v-model="params.user_id">
          <el-button slot="append" icon="el-icon-search" @click="searchData"></el-button>
        </el-input>
      </el-col>
      <el-col :md="6" :lg="5">
        <el-date-picker v-model="creat_time" type="daterange" start-placeholder="开始日期" ange-separator="至" end-placeholder="结束日期" value-format="yyyy/MM/dd" placeholder="选择日期范围" style="width:100%;" @change="dateChange" size=""></el-date-picker>
      </el-col>
      <el-col :span="2">
        <el-button type="primary" @click="exportData" v-loading="exportloading">导出</el-button>
      </el-col>
    </el-row>
    <el-table :data="userList" :height="wheight-130" v-loading="loading">
      <el-table-column prop="id" label="ID" width="100"></el-table-column>
      <el-table-column prop="user_id" label="会员id">
        <template slot-scope="scope">
          {{scope.row.user_id}}
        </template>
      </el-table-column>
      <el-table-column prop="name" label="姓名">
        <template slot-scope="scope">
          {{scope.row.name}}
        </template>
      </el-table-column>
      <el-table-column prop="mobile" label="手机号">
        <template slot-scope="scope">
          {{scope.row.mobile}}
        </template>
      </el-table-column>
      <el-table-column prop="channel_source_user_id" label="来源用户id">
        <template slot-scope="scope">
          {{scope.row.channel_source_user_id}}
        </template>
      </el-table-column>
      <el-table-column prop="channel_source_uid" label="来源渠道标识">
        <template slot-scope="scope">
          {{scope.row.channel_source_uid}}
        </template>
      </el-table-column>
      <el-table-column prop="Yk_mobile" label="推荐人手机号">
        <template slot-scope="scope">
          {{scope.row.Yk_mobile}}
        </template>
      </el-table-column>
      <el-table-column prop="creat_time" label="创建时间">
        <template slot-scope="scope">
            <span>{{scope.row.creat_time | datetime('yyyy-MM-dd hh:mm:ss')}}</span>
        </template>
      </el-table-column>
    </el-table>
    <div v-if="total_count > params.page_size" class="content-center content-top-padded">
      <el-pagination
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :current-page.sync="params.page"
        :total="total_count" :page-size="params.page_size">
      </el-pagination>
    </div>
  </div>
</template>
<script>
  import {mapGetters} from 'vuex'
  import {Message} from 'element-ui'
  import {
    SdbaoList,
    pullOrder,
    SdbaoExport
  } from '../../../api/baoxian'

  export default {
    data() {
      return {
        creat_time:'',
        isEdit: false,
        userList: [],
        loading: false,
        exportloading:false,
        total_count: 0,
        params: {
          page: 1,
          page_size: 20,
          user_id: ''
        },

        resList: [{label: 'true', value: 'true'},
          {label: 'false', value: 'false'}
        ],
        form: {
          id: '',

          description: ''
        },

        employeeDialog: false,
        predefineColors: ['#ff4500', '#ff8c00', '#ffd700', '#90ee90', '#00ced1', '#1e90ff', '#c71585']
      }
    },
    computed: {
      ...mapGetters([
        'wheight'
      ])
    },
    methods: {
      saveTimeData() {
        this.employeeDialog = false
        if (this.form.id) {
          // eslint-disable-next-line no-undef
          pullOrder(this.form).then(res => {
              this.$message({
                type: 'success',
                message: '获取成功'
              })
              this.getDataList()

          })
        } else {
          this.$message.error('缺少Id')
          this.getDataList()
        }
      },
      exportData() {
        this.exportloading = true
        this.params.export = 1
        SdbaoExport(this.params).then(res => {
          this.exportloading = false
          console.log(res.status==200)
          if (res.status) {
            this.$message({
              type: 'success',
              message: '已加入执行队列，请在设置-导出列表中下载'
            })
            return
          } else if (res.data.data.url) {
            this.downloadUrl = res.data.url
            this.downloadName = res.data.filename
            this.downloadView = true
          } else {
            this.$message({
              type: 'error',
              message: '无内容可导出 或 执行失败，请检查重试'
            })
            return
          }
        }).catch(error => {
          this.exportloading = false
        })
      },
      // eslint-disable-next-line camelcase
      handleCurrentChange(page_num) {
        // eslint-disable-next-line camelcase
        this.params.page = page_num
        this.getDataList()
      },
      addTemplate() { // 添加
        this.employeeDialog = true
        // eslint-disable-next-line standard/object-curly-even-spacing
        this.form = {tag_id: '', tag_name: '', tag_color: '#ff1939', font_color: '#ffffff', description: ''}
      },
      editAction(index, row) { // 编辑
        this.form = row
        this.employeeDialog = true
      },
      preview(index, row) { // 预览弹框
        this.dialogVisible = true
        this.dataInfo = row
      },
      searchData() {
          this.params.page = 1
          console.log(this.params);
          this.getDataList()
      },
      getDataList() {
        this.loading = true
        SdbaoList(this.params).then(response => {
          this.userList = response.data.data.list
          this.total_count = response.data.data.total_count
          this.loading = false
          // eslint-disable-next-line handle-callback-err
        }).catch(error => {
          this.loading = false
          this.$message({
            type: 'error',
            message: '获取列表信息出错'
          })
        })
      },

      getTaskTime(strDate) {
        let date = new Date(strDate)
        let y = date.getFullYear()
        let m = date.getMonth() + 1
        m = m < 10 ? ('0' + m) : m
        let d = date.getDate()
        d = d < 10 ? ('0' + d) : d
        let str = y + '-' + m + '-' + d
        return str
      },
      getTimeStr(date) {
        return this.getTaskTime(new Date(parseInt(date) * 1000))
      },
      handleCancelLabelsDialog() {
        this.employeeDialog = false
      },
      dateChange (val) {
        console.log(val)

        if (val.length > 0) {
          this.time_start_begin = this.dateStrToTimeStamp(val[0] + ' 00:00:00')
          this.time_start_end = this.dateStrToTimeStamp(val[1] + ' 23:59:59')
          this.params.time_start_begin = this.time_start_begin
          this.params.time_start_end = this.time_start_end
        } else {
          this.time_start_begin = ''
          this.time_start_end = ''
          this.params.time_start_begin = ''
          this.params.time_start_end = ''
        }
        this.params.page = 1

        this.getDataList()
      },
      dateStrToTimeStamp (str) {
        return Date.parse(new Date(str))/1000
      },
    },

    mounted() {
      this.getDataList()
    }
  }
</script>
<style scoped lang="scss">
  .el-row {
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }

    img {
      width: 90%;
    }
  }

  .el-col {
    border-radius: 4px;
  }

  .bg-purple-dark {
    background: #99a9bf;
  }

  .bg-purple {
    background: #d3dce6;
  }

  .bg-purple-light {
    background: #e5e9f2;
  }

  .grid-content {
    border-radius: 4px;
    min-height: 10px;

    img {
      width: 90%;
    }
  }

  .row-bg {
    padding: 10px 20px;
    background-color: #f9fafc;
  }

  .service-label .el-checkbox:first-child {
    margin-left: 15px;
  }

  .service-label .el-input:first-child {
    margin-left: 15px;
  }

  .grid-detail {
    max-height: 300px;
    overflow-y: scroll;
    margin-bottom: 20px;
  }

  .el-carousel {
    width: 375px;
  }
</style>
<style lang="scss">
  .grid-detail {
    table, .detail-content-wrap, .detail-content-item {
      width: 100% !important;
    }

    img {
      width: 100%;
    }
  }

  .grid-attribute {
    table {
      width: 100% !important;
    }
  }
</style>



// WEBPACK FOOTER //
// user.vue?7603fe54